module.exports = __webpack_public_path__ + "img/elemento3.75aec35a.png";